import { AppBar, Avatar, Button, Divider, Drawer, IconButton, List, ListItem, Modal, Toolbar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CAMPAGNE, FAQ, LOGIN, PROFILO, ROOT, POSTLOGINLANDING, SCREENINGCOLONRETTO, SCREENINGMAMMOGRAFICO, ESITI, PRIVACY, CONTATTI } from "../../global/urlMapping";
import { ArrowBack, ArrowForwardIos, Close, Logout } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import images from "../../resources/export";
import { useEffect, useState } from "react";
import { isAuthenticatedSelector } from "../../modules/auth/selectors";
import { isAuthenticatedAction, logoutAction, } from "../../modules/auth/actions";
import { profiloAriannaSelector } from "../../modules/screening/selectors";
import { resetStateWithoutAuthAction } from "../../modules/reset/actions";
import { ReactComponent as Warning } from "../../resources/icone/warning.svg"
import { setCampagnaAction } from "../../modules/persistentStore/actions";
import { generaLog } from "../../functions/utils";
import { ricercaIscrizioneSelector } from "../../modules/anagrafe/selectors";
import { ASL_3, ASL_5 } from "../../global/multiAsl";


export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(isAuthenticatedSelector)
  const datiIscrizioneAsr = useSelector(ricercaIscrizioneSelector)?.value?.DatiMinimiIscrizione
  const aslAssistito = datiIscrizioneAsr?.CodiceAreaAssistenza ?? datiIscrizioneAsr?.CodiceAslAssistenza
  const profiloArianna = useSelector(profiloAriannaSelector)
  const [anchorEl, setAnchorEl] = useState(false);
  const [modalConferma, setModalConferma] = useState(false);

  const handleClick = () => {
    setAnchorEl(true);
  };
  const handleClose = () => {
    setAnchorEl(false);
  };
  const onClickLogout = () => {
    generaLog("Logout", "log")
    dispatch(resetStateWithoutAuthAction())
    dispatch(logoutAction())
    //handleLogout(authType)
    handleClose()
  }
  const getNomeCognomeUtente = () => {
    const nome = profiloArianna?.value?.patient?.patientGivenName === undefined ? "" : profiloArianna?.value?.patient?.patientGivenName;
    const cognome = profiloArianna?.value?.patient?.patientFamilyName === undefined ? "" : profiloArianna?.value?.patient?.patientFamilyName;
    return nome + " " + cognome;
  }
  const getInizialiUtente = () => {
    const nome = profiloArianna?.value?.patient?.patientGivenName === undefined ? "" : profiloArianna?.value?.patient?.patientGivenName;
    const cognome = profiloArianna?.value?.patient?.patientFamilyName === undefined ? "" : profiloArianna?.value?.patient?.patientFamilyName;
    return `${nome?.charAt(0)}${cognome?.charAt(0)}`
  }

  const switchLogoAsl = () => {
    if (aslAssistito === ASL_3.codice)
      return <img src={images.loghi.logoAsl3} style={{ width: "35%" }} alt="logo-asl3" onClick={() => { window.location.href = process.env.REACT_APP_URL_ASL3 }} className="change-cursor" />
    if (aslAssistito === ASL_5.codice)
      return <img src={images.loghi.logoAsl5} style={{ width: "35%" }} alt="logo-asl5" onClick={() => { window.location.href = process.env.REACT_APP_URL_ASL5 }} className="change-cursor" />

  }

  useEffect(() => {
    dispatch(isAuthenticatedAction())
  }, [dispatch])
  return (
    <>
      <AppBar
        position="relative"
        sx={{
          display: "flex",
          backgroundColor: "#005397 !important",
          height: "150px",
          boxShadow: "none",
          borderBottomLeftRadius: "25px",
          borderBottomRightRadius: "25px",
        }}>
        <Box sx={{
          backgroundColor: "white",
          minHeight: "100px",
          width: "100%",
          margin: "auto 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between", align: "center", width: "100%", }}>
            <Box
              sx={{
                display: "flex",
                width: "40px",
                backgroundColor: "transparent",
                alignItems: "flex-start",
              }}
            >
              {location.pathname !== ROOT && (
                <IconButton
                  aria-label="Torna indietro"
                  onClick={() => {
                    if (location.pathname === POSTLOGINLANDING) navigate(ROOT);
                    else if (location.pathname === SCREENINGCOLONRETTO || location.pathname === SCREENINGMAMMOGRAFICO || location.pathname === LOGIN) navigate(CAMPAGNE)
                    else if (location.pathname === CAMPAGNE) navigate(ROOT)
                    else navigate(-1);
                  }}
                >
                  <ArrowBack sx={{ color: "#005397 !important", fontSize: "35px" }} />
                </IconButton>
              )}
            </Box>

            <Box
              id="returnHome"
              sx={{
                height: "100%",
                display: "flex",
                backgroundColor: "transparent",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Box sx={{ width: "50%", display: 'flex', gap: '3vw', justifyContent: "center" }}>
                {
                  isAuthenticated &&
                  switchLogoAsl()
                }
                {
                  !isAuthenticated &&
                  <>
                    <img src={images.loghi.logoAsl3} style={{ width: "20%" }} alt="logo-asl3" onClick={() => { window.location.href = process.env.REACT_APP_URL_ASL3 }} className="change-cursor" />
                    <img src={images.loghi.logoAsl5} style={{ width: "20%" }} alt="logo-asl5" onClick={() => { window.location.href = process.env.REACT_APP_URL_ASL5 }} className="change-cursor" />
                  </>
                }

              </Box>
            </Box>

            {isAuthenticated && getInizialiUtente() !== "" ?
              <IconButton
                id="loginAvvenuta"
                onClick={handleClick}
                sx={{
                  backgroundColor: "transparent",
                  height: "100%",
                }}
              >
                <Avatar
                  sx={{
                    border: "2px solid #005397",
                    height: "45px",
                    width: "45px",
                    margin: "auto",
                    backgroundColor: "white",
                  }}
                >
                  <Typography sx={{ color: "#005397", fontSize: "20px", fontWeight: 600 }}>
                    {getInizialiUtente()}
                  </Typography>
                </Avatar>
              </IconButton>
              :
              <IconButton
                onClick={handleClick}
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ alignItems: "end" }}
              >
                <MenuIcon sx={{ color: "#005397 !important", fontSize: "45px" }} />
              </IconButton>
            }

          </Toolbar>
        </Box >
      </AppBar >


      <Drawer
        anchor="right"
        open={anchorEl}
        onClose={() => handleClose()}
      >
        <List
          sx={{ height: "100vh", width: { xs: "250px", md: "380px" }, display: "flex", flexDirection: "column", backgroundColor: "white" }}
        >
          <Box
            sx={{
              height: isAuthenticated ? { md: "250px", xs: "220px" } : "150px",
              paddingBottom: { md: "60px", xs: "50px" },
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              background: "#005397",
              marginTop: "-20px",
            }}
          >
            <ListItem
              sx={{
                paddingTop: "35px",
                paddingLeft: "0px",
                height: "50px",
                display: "flex",
                justifyContent: "flex-end",
                width: "30%",
                float: "right",
                backgroundColor: "transparent",
              }}
            >
              <IconButton
                onClick={() => handleClose()}
                sx={{ display: "flex", justifyContent: "flex-end" }}
                aria-label="Chiudi menu"
              >
                <Close sx={{ color: "white", fontSize: "30px" }} />
              </IconButton>
            </ListItem>
            {
              isAuthenticated ?
                <>
                  <ListItem
                    sx={{
                      paddingTop: "20px",
                      paddingLeft: "0px",
                      height: "90px",
                      display: "flex",
                      flexDirection: "column",
                      width: "70%",
                      backgroundColor: "transparent",
                      margin: "auto",
                      justifyContent: "flex-start"
                    }}
                  >
                    <Box sx={{ height: "100%", display: "flex", width: "100%", justifyContent: "flex-start" }}>
                      <Avatar
                        sx={{
                          border: "2px solid white",
                          height: "75px",
                          width: "75px",
                          backgroundColor: "#005397 !important",
                          marginLeft: "20px",
                        }}
                      >
                        <Avatar
                          sx={{
                            border: "1px solid white",
                            backgroundColor: "white !important",
                            height: "65px",
                            width: "65px",
                          }}
                        >
                          <Typography sx={{ color: "#005397", fontSize: "30px", textAlign: "center", fontWeight: 500 }}>
                            {getInizialiUtente()}
                          </Typography>
                        </Avatar>
                      </Avatar>
                    </Box>
                  </ListItem>
                  <ListItem
                    sx={{
                      height: { md: "160px", xs: "130px" },
                      paddingLeft: "0px",
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "transparent",
                      margin: "auto",
                    }}
                  >
                    <Box
                      sx={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        margin: "auto",
                        justifyContent: "space-between"
                      }}
                    >
                      <Typography sx={{ color: "white", fontSize: { md: "18px", xs: "14px" }, marginLeft: "20px" }}>
                        Ciao
                      </Typography>
                      <Typography
                        sx={{ color: "white", fontSize: { md: "18px", xs: "14px" }, fontWeight: 600, marginLeft: "20px" }}
                      >
                        {getNomeCognomeUtente()}
                      </Typography>
                      <Typography
                        sx={{ color: "white", fontSize: { md: "18px", xs: "14px" }, marginLeft: "20px" }}
                      >
                        {profiloArianna?.value?.patient?.fiscalCode}
                      </Typography>
                      <Button
                        sx={{
                          borderWidth: '2px',
                          borderColor: 'white',
                          "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                          color: 'white',
                          borderRadius: '20px',
                          fontWeight: 600,
                          fontSize: { xs: "9px", md: "14px" },
                          margin: "auto",
                          marginLeft: "20px",
                        }}
                        variant="outlined"
                        onClick={() => {
                          navigate(PROFILO)
                          handleClose()
                        }}
                      >
                        Visualizza Profilo
                      </Button>
                    </Box>
                  </ListItem>
                </>
                :
                <>
                  <ListItem
                    sx={{
                      height: "100px",
                      paddingLeft: "0px",
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "transparent",
                      margin: "auto",
                    }}
                  >
                    <Box
                      sx={{
                        height: "100px",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        justifyContent: "flex-start",
                        margin: "auto",
                      }}
                    >
                      <Typography sx={{ color: "white", fontSize: "18px", marginLeft: "20px", marginTop: "10px" }}>
                        Benvenuto in Regione Liguria
                      </Typography>
                    </Box>
                  </ListItem>
                </>
            }
          </Box>
          <List
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "transparent",
              margin: "0px",
              paddingBottom: "0px",
            }}
          >
            <ListItem
              sx={{
                height: "50px",
                backgroundColor: "transparent",
                width: "95%",
                display: "flex",
                margin: "auto",
                paddingLeft: "0px",
                paddingRight: "0px",
              }}
            >
              <Button
                onClick={() => {
                  navigate(ROOT)
                  handleClose()
                }}
                className="button"
                sx={{ justifyContent: "flex-start", borderBottom: "1px solid gainsboro", borderRadius: "0px" }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "18px" },
                    fontWeight: 400,
                    textTransform: "none",
                    color: "#005397",
                    textAlign: "left",
                    margin: { xs: "10px 0", md: "5px 0" }
                  }}
                >
                  Home
                </Typography>
                <ArrowForwardIos sx={{ fontSize: "14px", margin: "auto", marginRight: "0px", color: "#005397" }} />
              </Button>
            </ListItem>
            <ListItem
              sx={{
                height: "50px",
                backgroundColor: "transparent",
                width: "95%",
                display: "flex",
                margin: "auto",
                paddingLeft: "0px",
                paddingRight: "0px",
              }}
            >
              <Button
                onClick={() => {
                  navigate(CONTATTI)
                  handleClose()
                }}
                className="button"
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  borderBottom: "1px solid gainsboro",
                  borderRadius: "0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "18px" },
                    fontWeight: 400,
                    textTransform: "none",
                    color: "#005397",
                    textAlign: "left",
                    margin: { xs: "10px 0", md: "5px 0" }
                  }}
                >
                  Contatti e Informazioni
                </Typography>
                <ArrowForwardIos sx={{ color: "#005397", fontSize: "14px", margin: "auto", marginRight: "0px" }} />
              </Button>
            </ListItem>
            <ListItem
              sx={{
                height: "50px",
                backgroundColor: "transparent",
                width: "95%",
                display: "flex",
                margin: "auto",
                paddingLeft: "0px",
                paddingRight: "0px",
              }}
            >
              <Button
                onClick={() => {
                  navigate(FAQ)
                  handleClose()
                }}
                className="button"
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  borderBottom: "1px solid gainsboro",
                  borderRadius: "0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "18px" },
                    fontWeight: 400,
                    textTransform: "none",
                    color: "#005397",
                    textAlign: "left",
                    margin: { xs: "10px 0", md: "5px 0" }
                  }}
                >
                  FAQ
                </Typography>
                <ArrowForwardIos sx={{ color: "#005397", fontSize: "14px", margin: "auto", marginRight: "0px" }} />
              </Button>
            </ListItem>
            <ListItem
              sx={{
                height: "50px",
                backgroundColor: "transparent",
                width: "95%",
                display: "flex",
                margin: "auto",
                paddingLeft: "0px",
                paddingRight: "0px",
              }}
            >
              <Button
                onClick={() => {
                  navigate(CAMPAGNE)
                  handleClose()
                }}
                className="button"
                sx={{ justifyContent: "flex-start", borderBottom: "1px solid gainsboro", borderRadius: "0px" }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "18px" },
                    fontWeight: 400,
                    textTransform: "none",
                    color: "#005397",
                    textAlign: "left",
                    margin: { xs: "10px 0", md: "5px 0" }
                  }}
                >
                  Campagne di screening
                </Typography>
                <ArrowForwardIos sx={{ fontSize: "14px", margin: "auto", marginRight: "0px", color: "#005397" }} />
              </Button>
            </ListItem>
            {
              <ListItem
                sx={{
                  height: { xs: "80px", md: "50px" },
                  backgroundColor: "transparent",
                  width: "95%",
                  display: "flex",
                  margin: "auto",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                }}
              >
                <Button
                  onClick={() => {
                    dispatch(setCampagnaAction("ESITI"))
                    navigate(ESITI)
                    handleClose()
                  }}
                  className="button"
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    borderBottom: "1px solid gainsboro",
                    borderRadius: "0px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "18px" },
                      fontWeight: 400,
                      textTransform: "none",
                      color: "#005397",
                      textAlign: "left",
                      margin: { xs: "10px 0", md: "5px 0" }
                    }}
                  >
                    Consultazione esiti di primo livello
                  </Typography>

                  <ArrowForwardIos sx={{ color: "#005397", fontSize: "14px", margin: "auto", marginRight: "0px" }} />
                </Button>
              </ListItem>
            }

            <ListItem
              sx={{
                height: "50px",
                backgroundColor: "transparent",
                width: "95%",
                display: "flex",
                margin: "auto",
                paddingLeft: "0px",
                paddingRight: "0px",
              }}
            >
              <Button
                onClick={() => {
                  navigate(PRIVACY)
                  handleClose()
                }}
                className="button"
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  borderBottom: "1px solid gainsboro",
                  borderRadius: "0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "18px" },
                    fontWeight: 400,
                    textTransform: "none",
                    color: "#005397",
                    textAlign: "left",
                    margin: { xs: "10px 0", md: "5px 0" }
                  }}
                >
                  Privacy policy
                </Typography>
                <ArrowForwardIos sx={{ color: "#005397", fontSize: "14px", margin: "auto", marginRight: "0px" }} />
              </Button>
            </ListItem>

            <ListItem
              sx={{
                height: "100%",
                backgroundColor: "transparent",
                margin: "auto",
                width: "95%",
                display: "flex",
                marginTop: "30px",
                justifyContent: "flex-end",
                paddingLeft: "0px",
                paddingRight: "0px",
                position: "relative",
              }}
            >
              {
                isAuthenticated &&
                <Button
                  className="button"
                  aria-label="Esci"
                  sx={{
                    justifyContent: "flex-start",
                    bottom: "0px",
                    position: "absolute",
                    borderTop: "1px solid gainsboro",
                  }}
                  onClick={() => setModalConferma(true)}
                  disabled={!isAuthenticated}
                >
                  <Logout
                    sx={{ fontSize: "25px", color: "#005397", margin: "0px 20px 0px 0px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 400,
                      textTransform: "none",
                      color: "#005397",
                      textAlign: "left",
                      margin: "10px 0",
                    }}
                  >
                    Esci
                  </Typography>
                </Button>
              }
            </ListItem>
          </List>
        </List>
      </Drawer>

      {
        modalConferma &&
        <Modal
          open={modalConferma}
          disableAutoFocus
          sx={{ width: "100%", display: "flex" }}
        >
          <Box
            sx={{
              width: "380px",
              minHeight: "320px",
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              backgroundColor: "white",
              borderRadius: "20px",
            }}
          >
            <Box
              sx={{
                minHeight: "120px",
                display: "flex",
                width: "100%",
                margin: "auto",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Warning
                sx={{
                  display: "flex",
                  margin: "auto",
                }}
              />
              <Typography
                sx={{
                  color: "#D1AE00",
                  wordWrap: "break-word",
                  margin: "auto",
                  fontSize: "20px",
                  textAlign: "center",
                  marginBottom: "5px"
                }}
                component="h1"
              >
                Attenzione
              </Typography>
            </Box>
            <Divider
              variant="middle"
              sx={{
                width: "70%",
                margin: "0px auto",
              }}
            />
            <Typography
              sx={{
                fontSize: "16px",
                color: "black",
                fontWeight: "medium",
                textAlign: "center",
                margin: "auto",
                mx: "10px"
              }}
            >
              Sei sicuro di voler effettuare il logout?
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                mt: "20px",
                mb: "20px",
              }}
            >
              <Button
                sx={{
                  borderWidth: '2px',
                  borderColor: '#005397',
                  "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                  color: '#005397',
                  borderRadius: '20px',
                  fontWeight: 700,
                  fontSize: { md: "14px", xs: "12px" }
                }}
                variant="outlined"
                onClick={() => { setModalConferma(false); }}
              >
                Annulla
              </Button>
              <Button
                sx={{
                  borderWidth: '2px',
                  borderColor: '#005397',
                  bgcolor: "#005397",
                  "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px' },
                  color: 'white',
                  borderRadius: '20px',
                  fontWeight: 700,
                  fontSize: { md: "14px", xs: "12px" }
                }}
                variant="outlined"
                onClick={() => { setModalConferma(false); onClickLogout() }}
              >
                Esci
              </Button>
            </Box>
          </Box>
        </Modal>
      }
    </>

  )
}